import _slicedToArray from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _get from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/get.js";
import _inherits from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import _regeneratorRuntime from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/regenerator/index.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { property } from 'lit/decorators.js';
import { Spherical, Vector3 } from 'three';
import { style } from '../decorators.js';
import { $ariaLabel, $container, $getModelIsVisible, $loadedTime, $needsRender, $onModelLoad, $onResize, $renderer, $scene, $tick, $updateStatus, $userInputElement, toVector3D } from '../model-viewer-base.js';
import { degreesToRadians, normalizeUnit } from '../styles/conversions.js';
import { StyleEvaluator } from '../styles/evaluators.js';
import { numberNode, parseExpressions } from '../styles/parsers.js';
import { DECAY_MILLISECONDS } from '../three-components/Damper.js';
import { ChangeSource, SmoothControls } from '../three-components/SmoothControls.js';
import { timeline } from '../utilities/animation.js';
// NOTE(cdata): The following "animation" timing functions are deliberately
// being used in favor of CSS animations. In Safari 12.1 and 13, CSS animations
// would cause the interaction prompt to glitch unexpectedly
// @see https://github.com/google/model-viewer/issues/839
var PROMPT_ANIMATION_TIME = 5000;
// For timing purposes, a "frame" is a timing agnostic relative unit of time
// and a "value" is a target value for the Frame.
var wiggle = timeline({
  initialValue: 0,
  keyframes: [{
    frames: 5,
    value: -1
  }, {
    frames: 1,
    value: -1
  }, {
    frames: 8,
    value: 1
  }, {
    frames: 1,
    value: 1
  }, {
    frames: 5,
    value: 0
  }, {
    frames: 18,
    value: 0
  }]
});
var fade = timeline({
  initialValue: 0,
  keyframes: [{
    frames: 1,
    value: 1
  }, {
    frames: 5,
    value: 1
  }, {
    frames: 1,
    value: 0
  }, {
    frames: 6,
    value: 0
  }]
});
export var DEFAULT_FOV_DEG = 30;
export var DEFAULT_MIN_FOV_DEG = 12;
export var DEFAULT_CAMERA_ORBIT = '0deg 75deg 105%';
var DEFAULT_CAMERA_TARGET = 'auto auto auto';
var DEFAULT_FIELD_OF_VIEW = 'auto';
var MINIMUM_RADIUS_RATIO = 2.2;
var AZIMUTHAL_QUADRANT_LABELS = ['front', 'right', 'back', 'left'];
var POLAR_TRIENT_LABELS = ['upper-', '', 'lower-'];
export var DEFAULT_INTERACTION_PROMPT_THRESHOLD = 3000;
export var INTERACTION_PROMPT = '. Use mouse, touch or arrow keys to move.';
export var InteractionPromptStrategy = {
  AUTO: 'auto',
  NONE: 'none'
};
export var InteractionPromptStyle = {
  BASIC: 'basic',
  WIGGLE: 'wiggle'
};
export var TouchAction = {
  PAN_Y: 'pan-y',
  PAN_X: 'pan-x',
  NONE: 'none'
};
export var fieldOfViewIntrinsics = function fieldOfViewIntrinsics() {
  return {
    basis: [degreesToRadians(numberNode(DEFAULT_FOV_DEG, 'deg'))],
    keywords: {
      auto: [null]
    }
  };
};
var minFieldOfViewIntrinsics = function minFieldOfViewIntrinsics() {
  return {
    basis: [degreesToRadians(numberNode(DEFAULT_MIN_FOV_DEG, 'deg'))],
    keywords: {
      auto: [null]
    }
  };
};
export var cameraOrbitIntrinsics = function () {
  var defaultTerms = parseExpressions(DEFAULT_CAMERA_ORBIT)[0].terms;
  var theta = normalizeUnit(defaultTerms[0]);
  var phi = normalizeUnit(defaultTerms[1]);
  return function (element) {
    var radius = element[$scene].idealCameraDistance();
    return {
      basis: [theta, phi, numberNode(radius, 'm')],
      keywords: {
        auto: [null, null, numberNode(105, '%')]
      }
    };
  };
}();
var minCameraOrbitIntrinsics = function minCameraOrbitIntrinsics(element) {
  var radius = MINIMUM_RADIUS_RATIO * element[$scene].boundingSphere.radius;
  return {
    basis: [numberNode(-Infinity, 'rad'), numberNode(Math.PI / 8, 'rad'), numberNode(radius, 'm')],
    keywords: {
      auto: [null, null, null]
    }
  };
};
var maxCameraOrbitIntrinsics = function maxCameraOrbitIntrinsics(element) {
  var orbitIntrinsics = cameraOrbitIntrinsics(element);
  var evaluator = new StyleEvaluator([], orbitIntrinsics);
  var defaultRadius = evaluator.evaluate()[2];
  return {
    basis: [numberNode(Infinity, 'rad'), numberNode(Math.PI - Math.PI / 8, 'rad'), numberNode(defaultRadius, 'm')],
    keywords: {
      auto: [null, null, null]
    }
  };
};
export var cameraTargetIntrinsics = function cameraTargetIntrinsics(element) {
  var center = element[$scene].boundingBox.getCenter(new Vector3());
  return {
    basis: [numberNode(center.x, 'm'), numberNode(center.y, 'm'), numberNode(center.z, 'm')],
    keywords: {
      auto: [null, null, null]
    }
  };
};
var HALF_PI = Math.PI / 2.0;
var THIRD_PI = Math.PI / 3.0;
var QUARTER_PI = HALF_PI / 2.0;
var TAU = 2.0 * Math.PI;
export var $controls = Symbol('controls');
export var $panElement = Symbol('panElement');
export var $promptElement = Symbol('promptElement');
export var $promptAnimatedContainer = Symbol('promptAnimatedContainer');
export var $fingerAnimatedContainers = Symbol('fingerAnimatedContainers');
var $deferInteractionPrompt = Symbol('deferInteractionPrompt');
var $updateAria = Symbol('updateAria');
var $a11y = Symbol('a11y');
var $updateA11y = Symbol('updateA11y');
var $updateCameraForRadius = Symbol('updateCameraForRadius');
var $cancelPrompts = Symbol('cancelPrompts');
var $onChange = Symbol('onChange');
var $onPointerChange = Symbol('onPointerChange');
var $waitingToPromptUser = Symbol('waitingToPromptUser');
var $userHasInteracted = Symbol('userHasInteracted');
var $promptElementVisibleTime = Symbol('promptElementVisibleTime');
var $lastPromptOffset = Symbol('lastPromptOffset');
var $cancellationSource = Symbol('cancellationSource');
var $lastSpherical = Symbol('lastSpherical');
var $jumpCamera = Symbol('jumpCamera');
var $initialized = Symbol('initialized');
var $maintainThetaPhi = Symbol('maintainThetaPhi');
var $syncCameraOrbit = Symbol('syncCameraOrbit');
var $syncFieldOfView = Symbol('syncFieldOfView');
var $syncCameraTarget = Symbol('syncCameraTarget');
var $syncMinCameraOrbit = Symbol('syncMinCameraOrbit');
var $syncMaxCameraOrbit = Symbol('syncMaxCameraOrbit');
var $syncMinFieldOfView = Symbol('syncMinFieldOfView');
var $syncMaxFieldOfView = Symbol('syncMaxFieldOfView');
export var ControlsMixin = function ControlsMixin(ModelViewerElement) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
  var ControlsModelViewerElement = /*#__PURE__*/function (_ModelViewerElement, _ref, _ref2) {
    _inherits(ControlsModelViewerElement, _ModelViewerElement);
    var _super = _createSuper(ControlsModelViewerElement);
    function ControlsModelViewerElement() {
      var _this;
      _classCallCheck(this, ControlsModelViewerElement);
      _this = _super.apply(this, arguments);
      _this.cameraControls = false;
      _this.cameraOrbit = DEFAULT_CAMERA_ORBIT;
      _this.cameraTarget = DEFAULT_CAMERA_TARGET;
      _this.fieldOfView = DEFAULT_FIELD_OF_VIEW;
      _this.minCameraOrbit = 'auto';
      _this.maxCameraOrbit = 'auto';
      _this.minFieldOfView = 'auto';
      _this.maxFieldOfView = 'auto';
      _this.interactionPromptThreshold = DEFAULT_INTERACTION_PROMPT_THRESHOLD;
      _this.interactionPrompt = InteractionPromptStrategy.AUTO;
      _this.interactionPromptStyle = InteractionPromptStyle.WIGGLE;
      _this.orbitSensitivity = 1;
      _this.zoomSensitivity = 1;
      _this.panSensitivity = 1;
      _this.touchAction = TouchAction.NONE;
      _this.disableZoom = false;
      _this.disablePan = false;
      _this.disableTap = false;
      _this.interpolationDecay = DECAY_MILLISECONDS;
      _this.a11y = null;
      _this[_a] = _this.shadowRoot.querySelector('.interaction-prompt');
      _this[_b] = _this.shadowRoot.querySelector('#prompt');
      _this[_c] = [_this.shadowRoot.querySelector('#finger0'), _this.shadowRoot.querySelector('#finger1')];
      _this[_d] = _this.shadowRoot.querySelector('.pan-target');
      _this[_e] = 0;
      _this[_f] = Infinity;
      _this[_g] = false;
      _this[_h] = false;
      _this[_j] = ChangeSource.AUTOMATIC;
      _this[_k] = new SmoothControls(_this[$scene].camera, _this[$userInputElement], _this[$scene]);
      _this[_l] = new Spherical();
      _this[_m] = false;
      _this[_o] = false;
      _this[_p] = false;
      _this[_q] = {};
      _this[_r] = function () {
        var source = _this[$controls].changeSource;
        _this[$cancellationSource] = source;
        if (source === ChangeSource.USER_INTERACTION) {
          _this[$userHasInteracted] = true;
          _this[$deferInteractionPrompt]();
        }
      };
      _this[_s] = function () {
        _this[$updateAria]();
        _this[$needsRender]();
        var source = _this[$controls].changeSource;
        _this.dispatchEvent(new CustomEvent('camera-change', {
          detail: {
            source: source
          }
        }));
      };
      _this[_t] = function (event) {
        _this[$container].classList.toggle('pointer-tumbling', event.type === 'pointer-change-start');
      };
      return _this;
    }
    _createClass(ControlsModelViewerElement, [{
      key: "inputSensitivity",
      get: function get() {
        return this[$controls].inputSensitivity;
      },
      set: function set(value) {
        this[$controls].inputSensitivity = value;
      }
    }, {
      key: "getCameraOrbit",
      value: function getCameraOrbit() {
        var _this$$lastSpherical = this[$lastSpherical],
          theta = _this$$lastSpherical.theta,
          phi = _this$$lastSpherical.phi,
          radius = _this$$lastSpherical.radius;
        return {
          theta: theta,
          phi: phi,
          radius: radius,
          toString: function toString() {
            return "".concat(this.theta, "rad ").concat(this.phi, "rad ").concat(this.radius, "m");
          }
        };
      }
    }, {
      key: "getCameraTarget",
      value: function getCameraTarget() {
        return toVector3D(this[$renderer].isPresenting ? this[$renderer].arRenderer.target : this[$scene].getTarget());
      }
    }, {
      key: "getFieldOfView",
      value: function getFieldOfView() {
        return this[$controls].getFieldOfView();
      }
      // Provided so user code does not have to parse these from attributes.
    }, {
      key: "getMinimumFieldOfView",
      value: function getMinimumFieldOfView() {
        return this[$controls].options.minimumFieldOfView;
      }
    }, {
      key: "getMaximumFieldOfView",
      value: function getMaximumFieldOfView() {
        return this[$controls].options.maximumFieldOfView;
      }
    }, {
      key: "getIdealAspect",
      value: function getIdealAspect() {
        return this[$scene].idealAspect;
      }
    }, {
      key: "jumpCameraToGoal",
      value: function jumpCameraToGoal() {
        this[$jumpCamera] = true;
        this.requestUpdate($jumpCamera, false);
      }
    }, {
      key: "resetInteractionPrompt",
      value: function resetInteractionPrompt() {
        this[$lastPromptOffset] = 0;
        this[$promptElementVisibleTime] = Infinity;
        this[$userHasInteracted] = false;
        this[$waitingToPromptUser] = this.interactionPrompt === InteractionPromptStrategy.AUTO && this.cameraControls;
      }
    }, {
      key: "zoom",
      value: function zoom(keyPresses) {
        var event = new WheelEvent('wheel', {
          deltaY: -30 * keyPresses
        });
        this[$userInputElement].dispatchEvent(event);
      }
    }, {
      key: "connectedCallback",
      value: function connectedCallback() {
        _get(_getPrototypeOf(ControlsModelViewerElement.prototype), "connectedCallback", this).call(this);
        this[$controls].addEventListener('user-interaction', this[$cancelPrompts]);
        this[$controls].addEventListener('pointer-change-start', this[$onPointerChange]);
        this[$controls].addEventListener('pointer-change-end', this[$onPointerChange]);
      }
    }, {
      key: "disconnectedCallback",
      value: function disconnectedCallback() {
        _get(_getPrototypeOf(ControlsModelViewerElement.prototype), "disconnectedCallback", this).call(this);
        this[$controls].removeEventListener('user-interaction', this[$cancelPrompts]);
        this[$controls].removeEventListener('pointer-change-start', this[$onPointerChange]);
        this[$controls].removeEventListener('pointer-change-end', this[$onPointerChange]);
      }
    }, {
      key: "updated",
      value: function updated(changedProperties) {
        var _this2 = this;
        _get(_getPrototypeOf(ControlsModelViewerElement.prototype), "updated", this).call(this, changedProperties);
        var controls = this[$controls];
        var scene = this[$scene];
        if (changedProperties.has('cameraControls')) {
          if (this.cameraControls) {
            controls.enableInteraction();
            if (this.interactionPrompt === InteractionPromptStrategy.AUTO) {
              this[$waitingToPromptUser] = true;
            }
          } else {
            controls.disableInteraction();
            this[$deferInteractionPrompt]();
          }
          this[$userInputElement].setAttribute('aria-label', this[$ariaLabel]);
        }
        if (changedProperties.has('disableZoom')) {
          controls.disableZoom = this.disableZoom;
        }
        if (changedProperties.has('disablePan')) {
          controls.enablePan = !this.disablePan;
        }
        if (changedProperties.has('disableTap')) {
          controls.enableTap = !this.disableTap;
        }
        if (changedProperties.has('interactionPrompt') || changedProperties.has('cameraControls') || changedProperties.has('src')) {
          if (this.interactionPrompt === InteractionPromptStrategy.AUTO && this.cameraControls && !this[$userHasInteracted]) {
            this[$waitingToPromptUser] = true;
          } else {
            this[$deferInteractionPrompt]();
          }
        }
        if (changedProperties.has('interactionPromptStyle')) {
          this[$promptAnimatedContainer].style.opacity = this.interactionPromptStyle == InteractionPromptStyle.BASIC ? '1' : '0';
        }
        if (changedProperties.has('touchAction')) {
          var touchAction = this.touchAction;
          controls.applyOptions({
            touchAction: touchAction
          });
          controls.updateTouchActionStyle();
        }
        if (changedProperties.has('orbitSensitivity')) {
          controls.orbitSensitivity = this.orbitSensitivity;
        }
        if (changedProperties.has('zoomSensitivity')) {
          controls.zoomSensitivity = this.zoomSensitivity;
        }
        if (changedProperties.has('panSensitivity')) {
          controls.panSensitivity = this.panSensitivity;
        }
        if (changedProperties.has('interpolationDecay')) {
          controls.setDamperDecayTime(this.interpolationDecay);
          scene.setTargetDamperDecayTime(this.interpolationDecay);
        }
        if (changedProperties.has('a11y')) {
          this[$updateA11y]();
        }
        if (this[$jumpCamera] === true) {
          Promise.resolve().then(function () {
            controls.jumpToGoal();
            scene.jumpToGoal();
            _this2[$onChange]();
            _this2[$jumpCamera] = false;
          });
        }
      }
    }, {
      key: "updateFraming",
      value: function () {
        var _updateFraming = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var scene, oldFramedFoV, newFramedFoV, zoom;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                scene = this[$scene];
                oldFramedFoV = scene.adjustedFoV(scene.framedFoVDeg);
                _context.next = 4;
                return scene.updateFraming();
              case 4:
                newFramedFoV = scene.adjustedFoV(scene.framedFoVDeg);
                zoom = this[$controls].getFieldOfView() / oldFramedFoV;
                this[$controls].setFieldOfView(newFramedFoV * zoom);
                this[$maintainThetaPhi] = true;
                this.requestUpdate('maxFieldOfView');
                this.requestUpdate('fieldOfView');
                this.requestUpdate('minCameraOrbit');
                this.requestUpdate('maxCameraOrbit');
                this.requestUpdate('cameraOrbit');
                _context.next = 15;
                return this.updateComplete;
              case 15:
              case "end":
                return _context.stop();
            }
          }, _callee, this);
        }));
        function updateFraming() {
          return _updateFraming.apply(this, arguments);
        }
        return updateFraming;
      }()
    }, {
      key: "interact",
      value: function interact(duration, finger0, finger1) {
        var _this3 = this;
        var inputElement = this[$userInputElement];
        var fingerElements = this[$fingerAnimatedContainers];
        if (fingerElements[0].style.opacity === '1') {
          console.warn('interact() failed because an existing interaction is running.');
          return;
        }
        var xy = new Array();
        xy.push({
          x: timeline(finger0.x),
          y: timeline(finger0.y)
        });
        var positions = [{
          x: xy[0].x(0),
          y: xy[0].y(0)
        }];
        if (finger1 != null) {
          xy.push({
            x: timeline(finger1.x),
            y: timeline(finger1.y)
          });
          positions.push({
            x: xy[1].x(0),
            y: xy[1].y(0)
          });
        }
        var startTime = performance.now();
        var _this$$scene = this[$scene],
          width = _this$$scene.width,
          height = _this$$scene.height;
        var rect = this.getBoundingClientRect();
        var dispatchTouches = function dispatchTouches(type) {
          var _iterator = _createForOfIteratorHelper(positions.entries()),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var _step$value = _slicedToArray(_step.value, 2),
                i = _step$value[0],
                position = _step$value[1];
              var _style = fingerElements[i].style;
              _style.transform = "translateX(".concat(width * position.x, "px) translateY(").concat(height * position.y, "px)");
              if (type === 'pointerdown') {
                _style.opacity = '1';
              } else if (type === 'pointerup') {
                _style.opacity = '0';
              }
              var init = {
                pointerId: i - 5678,
                pointerType: 'touch',
                target: inputElement,
                clientX: width * position.x + rect.x,
                clientY: height * position.y + rect.y,
                altKey: true // flag that this is not a user interaction
              };

              inputElement.dispatchEvent(new PointerEvent(type, init));
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        };
        var moveTouches = function moveTouches() {
          // Cancel interaction if something else moves the camera or input is
          // removed from the DOM.
          var changeSource = _this3[$cancellationSource];
          if (changeSource !== ChangeSource.AUTOMATIC || !inputElement.isConnected) {
            var _iterator2 = _createForOfIteratorHelper(_this3[$fingerAnimatedContainers]),
              _step2;
            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var fingerElement = _step2.value;
                fingerElement.style.opacity = '0';
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
            dispatchTouches('pointercancel');
            _this3.dispatchEvent(new CustomEvent('interact-stopped', {
              detail: {
                source: changeSource
              }
            }));
            document.removeEventListener('visibilitychange', onVisibilityChange);
            return;
          }
          var time = Math.min(1, (performance.now() - startTime) / duration);
          var _iterator3 = _createForOfIteratorHelper(positions.entries()),
            _step3;
          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var _step3$value = _slicedToArray(_step3.value, 2),
                i = _step3$value[0],
                position = _step3$value[1];
              position.x = xy[i].x(time);
              position.y = xy[i].y(time);
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
          dispatchTouches('pointermove');
          if (time < 1) {
            requestAnimationFrame(moveTouches);
          } else {
            dispatchTouches('pointerup');
            _this3.dispatchEvent(new CustomEvent('interact-stopped', {
              detail: {
                source: ChangeSource.AUTOMATIC
              }
            }));
            document.removeEventListener('visibilitychange', onVisibilityChange);
          }
        };
        var onVisibilityChange = function onVisibilityChange() {
          var elapsed = 0;
          if (document.visibilityState === 'hidden') {
            elapsed = performance.now() - startTime;
          } else {
            startTime = performance.now() - elapsed;
          }
        };
        document.addEventListener('visibilitychange', onVisibilityChange);
        dispatchTouches('pointerdown');
        this[$cancellationSource] = ChangeSource.AUTOMATIC;
        requestAnimationFrame(moveTouches);
      }
    }, {
      key: _ref,
      value: function value(style) {
        var controls = this[$controls];
        var scene = this[$scene];
        scene.framedFoVDeg = style[0] * 180 / Math.PI;
        controls.changeSource = ChangeSource.NONE;
        controls.setFieldOfView(scene.adjustedFoV(scene.framedFoVDeg));
        this[$cancelPrompts]();
      }
    }, {
      key: $syncCameraOrbit,
      value: function value(style) {
        var controls = this[$controls];
        if (this[$maintainThetaPhi]) {
          var _this$getCameraOrbit = this.getCameraOrbit(),
            theta = _this$getCameraOrbit.theta,
            phi = _this$getCameraOrbit.phi;
          style[0] = theta;
          style[1] = phi;
          this[$maintainThetaPhi] = false;
        }
        controls.changeSource = ChangeSource.NONE;
        controls.setOrbit(style[0], style[1], style[2]);
        this[$cancelPrompts]();
      }
    }, {
      key: $syncMinCameraOrbit,
      value: function value(style) {
        this[$controls].applyOptions({
          minimumAzimuthalAngle: style[0],
          minimumPolarAngle: style[1],
          minimumRadius: style[2]
        });
        this.jumpCameraToGoal();
      }
    }, {
      key: $syncMaxCameraOrbit,
      value: function value(style) {
        this[$controls].applyOptions({
          maximumAzimuthalAngle: style[0],
          maximumPolarAngle: style[1],
          maximumRadius: style[2]
        });
        this[$updateCameraForRadius](style[2]);
        this.jumpCameraToGoal();
      }
    }, {
      key: $syncMinFieldOfView,
      value: function value(style) {
        this[$controls].applyOptions({
          minimumFieldOfView: style[0] * 180 / Math.PI
        });
        this.jumpCameraToGoal();
      }
    }, {
      key: $syncMaxFieldOfView,
      value: function value(style) {
        var fov = this[$scene].adjustedFoV(style[0] * 180 / Math.PI);
        this[$controls].applyOptions({
          maximumFieldOfView: fov
        });
        this.jumpCameraToGoal();
      }
    }, {
      key: $syncCameraTarget,
      value: function value(style) {
        var _style2 = _slicedToArray(style, 3),
          x = _style2[0],
          y = _style2[1],
          z = _style2[2];
        if (!this[$renderer].arRenderer.isPresenting) {
          this[$scene].setTarget(x, y, z);
        }
        this[$controls].changeSource = ChangeSource.NONE;
        this[$renderer].arRenderer.updateTarget();
        this[$cancelPrompts]();
      }
    }, {
      key: $tick,
      value: function value(time, delta) {
        _get(_getPrototypeOf(ControlsModelViewerElement.prototype), $tick, this).call(this, time, delta);
        if (this[$renderer].isPresenting || !this[$getModelIsVisible]()) {
          return;
        }
        var controls = this[$controls];
        var scene = this[$scene];
        var now = performance.now();
        if (this[$waitingToPromptUser]) {
          if (this.loaded && now > this[$loadedTime] + this.interactionPromptThreshold) {
            this[$waitingToPromptUser] = false;
            this[$promptElementVisibleTime] = now;
            this[$promptElement].classList.add('visible');
          }
        }
        if (isFinite(this[$promptElementVisibleTime]) && this.interactionPromptStyle === InteractionPromptStyle.WIGGLE) {
          var animationTime = (now - this[$promptElementVisibleTime]) / PROMPT_ANIMATION_TIME % 1;
          var offset = wiggle(animationTime);
          var opacity = fade(animationTime);
          this[$promptAnimatedContainer].style.opacity = "".concat(opacity);
          if (offset !== this[$lastPromptOffset]) {
            var xOffset = offset * scene.width * 0.05;
            var deltaTheta = (offset - this[$lastPromptOffset]) * Math.PI / 16;
            this[$promptAnimatedContainer].style.transform = "translateX(".concat(xOffset, "px)");
            controls.changeSource = ChangeSource.AUTOMATIC;
            controls.adjustOrbit(deltaTheta, 0, 0);
            this[$lastPromptOffset] = offset;
          }
        }
        var cameraMoved = controls.update(time, delta);
        var targetMoved = scene.updateTarget(delta);
        if (cameraMoved || targetMoved) {
          this[$onChange]();
        }
      }
    }, {
      key: $deferInteractionPrompt,
      value: function value() {
        // Effectively cancel the timer waiting for user interaction:
        this[$waitingToPromptUser] = false;
        this[$promptElement].classList.remove('visible');
        this[$promptElementVisibleTime] = Infinity;
      }
      /**
       * Updates the camera's near and far planes to enclose the scene when
       * orbiting at the supplied radius.
       */
    }, {
      key: $updateCameraForRadius,
      value: function value(radius) {
        var maximumRadius = Math.max(this[$scene].farRadius(), radius);
        var near = 0;
        var far = Math.abs(2 * maximumRadius);
        this[$controls].updateNearFar(near, far);
      }
    }, {
      key: $updateAria,
      value: function value() {
        var _this$$controls$getCa = this[$controls].getCameraSpherical(this[$lastSpherical]),
          theta = _this$$controls$getCa.theta,
          phi = _this$$controls$getCa.phi;
        var azimuthalQuadrant = (4 + Math.floor((theta % TAU + QUARTER_PI) / HALF_PI)) % 4;
        var polarTrient = Math.floor(phi / THIRD_PI);
        var azimuthalQuadrantLabel = AZIMUTHAL_QUADRANT_LABELS[azimuthalQuadrant];
        var polarTrientLabel = POLAR_TRIENT_LABELS[polarTrient];
        var position = "".concat(polarTrientLabel).concat(azimuthalQuadrantLabel);
        var key = position;
        if (key in this[$a11y]) {
          this[$updateStatus](this[$a11y][key]);
        } else {
          this[$updateStatus]("View from stage ".concat(position));
        }
      }
    }, {
      key: $ariaLabel,
      get: function get() {
        var interactionPrompt = INTERACTION_PROMPT;
        if ('interaction-prompt' in this[$a11y]) {
          interactionPrompt = ". ".concat(this[$a11y]['interaction-prompt']);
        }
        return _get(_getPrototypeOf(ControlsModelViewerElement.prototype), $ariaLabel, this).replace(/\.$/, '') + (this.cameraControls ? interactionPrompt : '');
      }
    }, {
      key: $onResize,
      value: function () {
        var _value = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(event) {
          var controls, scene, oldFramedFoV, fovRatio, fov;
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                controls = this[$controls];
                scene = this[$scene];
                oldFramedFoV = scene.adjustedFoV(scene.framedFoVDeg); // The super of $onResize may update the scene's adjustedFoV, so we
                // compare the before and after to calculate the proper zoom.
                _get(_getPrototypeOf(ControlsModelViewerElement.prototype), $onResize, this).call(this, event);
                fovRatio = scene.adjustedFoV(scene.framedFoVDeg) / oldFramedFoV;
                fov = controls.getFieldOfView() * (isFinite(fovRatio) ? fovRatio : 1);
                controls.updateAspect(this[$scene].aspect);
                this.requestUpdate('maxFieldOfView', this.maxFieldOfView);
                _context2.next = 10;
                return this.updateComplete;
              case 10:
                this[$controls].setFieldOfView(fov);
                this.jumpCameraToGoal();
              case 12:
              case "end":
                return _context2.stop();
            }
          }, _callee2, this);
        }));
        function value(_x) {
          return _value.apply(this, arguments);
        }
        return value;
      }()
    }, {
      key: $onModelLoad,
      value: function value() {
        _get(_getPrototypeOf(ControlsModelViewerElement.prototype), $onModelLoad, this).call(this);
        if (this[$initialized]) {
          this[$maintainThetaPhi] = true;
        } else {
          this[$initialized] = true;
        }
        this.requestUpdate('maxFieldOfView', this.maxFieldOfView);
        this.requestUpdate('fieldOfView', this.fieldOfView);
        this.requestUpdate('minCameraOrbit', this.minCameraOrbit);
        this.requestUpdate('maxCameraOrbit', this.maxCameraOrbit);
        this.requestUpdate('cameraOrbit', this.cameraOrbit);
        this.requestUpdate('cameraTarget', this.cameraTarget);
        this.jumpCameraToGoal();
      }
    }, {
      key: _ref2,
      value: function value() {
        if (typeof this.a11y === 'string') {
          if (this.a11y.startsWith('{')) {
            try {
              this[$a11y] = JSON.parse(this.a11y);
            } catch (error) {
              console.warn('Error parsing a11y JSON:', error);
            }
          } else if (this.a11y.length > 0) {
            console.warn('Error not supported format, should be a JSON string:', this.a11y);
          } else {
            this[$a11y] = {};
          }
        } else if (typeof this.a11y === 'object' && this.a11y != null) {
          this[$a11y] = Object.assign({}, this.a11y);
        } else {
          this[$a11y] = {};
        }
        this[$userInputElement].setAttribute('aria-label', this[$ariaLabel]);
      }
    }]);
    return ControlsModelViewerElement;
  }(ModelViewerElement, (_a = $promptElement, _b = $promptAnimatedContainer, _c = $fingerAnimatedContainers, _d = $panElement, _e = $lastPromptOffset, _f = $promptElementVisibleTime, _g = $userHasInteracted, _h = $waitingToPromptUser, _j = $cancellationSource, _k = $controls, _l = $lastSpherical, _m = $jumpCamera, _o = $initialized, _p = $maintainThetaPhi, _q = $a11y, $syncFieldOfView), (_r = $cancelPrompts, _s = $onChange, _t = $onPointerChange, $updateA11y));
  __decorate([property({
    type: Boolean,
    attribute: 'camera-controls'
  })], ControlsModelViewerElement.prototype, "cameraControls", void 0);
  __decorate([style({
    intrinsics: cameraOrbitIntrinsics,
    observeEffects: true,
    updateHandler: $syncCameraOrbit
  }), property({
    type: String,
    attribute: 'camera-orbit',
    hasChanged: function hasChanged() {
      return true;
    }
  })], ControlsModelViewerElement.prototype, "cameraOrbit", void 0);
  __decorate([style({
    intrinsics: cameraTargetIntrinsics,
    observeEffects: true,
    updateHandler: $syncCameraTarget
  }), property({
    type: String,
    attribute: 'camera-target',
    hasChanged: function hasChanged() {
      return true;
    }
  })], ControlsModelViewerElement.prototype, "cameraTarget", void 0);
  __decorate([style({
    intrinsics: fieldOfViewIntrinsics,
    observeEffects: true,
    updateHandler: $syncFieldOfView
  }), property({
    type: String,
    attribute: 'field-of-view',
    hasChanged: function hasChanged() {
      return true;
    }
  })], ControlsModelViewerElement.prototype, "fieldOfView", void 0);
  __decorate([style({
    intrinsics: minCameraOrbitIntrinsics,
    updateHandler: $syncMinCameraOrbit
  }), property({
    type: String,
    attribute: 'min-camera-orbit',
    hasChanged: function hasChanged() {
      return true;
    }
  })], ControlsModelViewerElement.prototype, "minCameraOrbit", void 0);
  __decorate([style({
    intrinsics: maxCameraOrbitIntrinsics,
    updateHandler: $syncMaxCameraOrbit
  }), property({
    type: String,
    attribute: 'max-camera-orbit',
    hasChanged: function hasChanged() {
      return true;
    }
  })], ControlsModelViewerElement.prototype, "maxCameraOrbit", void 0);
  __decorate([style({
    intrinsics: minFieldOfViewIntrinsics,
    updateHandler: $syncMinFieldOfView
  }), property({
    type: String,
    attribute: 'min-field-of-view',
    hasChanged: function hasChanged() {
      return true;
    }
  })], ControlsModelViewerElement.prototype, "minFieldOfView", void 0);
  __decorate([style({
    intrinsics: fieldOfViewIntrinsics,
    updateHandler: $syncMaxFieldOfView
  }), property({
    type: String,
    attribute: 'max-field-of-view',
    hasChanged: function hasChanged() {
      return true;
    }
  })], ControlsModelViewerElement.prototype, "maxFieldOfView", void 0);
  __decorate([property({
    type: Number,
    attribute: 'interaction-prompt-threshold'
  })], ControlsModelViewerElement.prototype, "interactionPromptThreshold", void 0);
  __decorate([property({
    type: String,
    attribute: 'interaction-prompt'
  })], ControlsModelViewerElement.prototype, "interactionPrompt", void 0);
  __decorate([property({
    type: String,
    attribute: 'interaction-prompt-style'
  })], ControlsModelViewerElement.prototype, "interactionPromptStyle", void 0);
  __decorate([property({
    type: Number,
    attribute: 'orbit-sensitivity'
  })], ControlsModelViewerElement.prototype, "orbitSensitivity", void 0);
  __decorate([property({
    type: Number,
    attribute: 'zoom-sensitivity'
  })], ControlsModelViewerElement.prototype, "zoomSensitivity", void 0);
  __decorate([property({
    type: Number,
    attribute: 'pan-sensitivity'
  })], ControlsModelViewerElement.prototype, "panSensitivity", void 0);
  __decorate([property({
    type: String,
    attribute: 'touch-action'
  })], ControlsModelViewerElement.prototype, "touchAction", void 0);
  __decorate([property({
    type: Boolean,
    attribute: 'disable-zoom'
  })], ControlsModelViewerElement.prototype, "disableZoom", void 0);
  __decorate([property({
    type: Boolean,
    attribute: 'disable-pan'
  })], ControlsModelViewerElement.prototype, "disablePan", void 0);
  __decorate([property({
    type: Boolean,
    attribute: 'disable-tap'
  })], ControlsModelViewerElement.prototype, "disableTap", void 0);
  __decorate([property({
    type: Number,
    attribute: 'interpolation-decay'
  })], ControlsModelViewerElement.prototype, "interpolationDecay", void 0);
  __decorate([property()], ControlsModelViewerElement.prototype, "a11y", void 0);
  return ControlsModelViewerElement;
};